import { DatadogConfig } from '../../interfaces/jsconfig.interface';
import { jsConfig } from '../config/jsConfig';

/**
 * Shared deploy-environment name (e.g. 'test', 'prod') used as the `env` tag across every monitoring
 * backend. Sentry and Datadog intentionally report the same value so the two can be compared. It is
 * sourced from `sentryEnv` for historical reasons — the field predates Datadog and is the single
 * place the deploy environment is configured.
 */
export const deployEnv = (): string => jsConfig.sentryEnv;

/**
 * True when Datadog is switched on AND has the browser credentials it needs to initialise RUM.
 * Both the client bootstrap wiring and the Datadog backend gate on this so they can never diverge
 * (e.g. registering the RUM router / replay services while RUM itself stays un-initialised).
 */
export const isDatadogConfigured = (config: DatadogConfig | undefined = jsConfig.datadog): boolean =>
  config?.enabled === true && !!config.clientToken && !!config.applicationId;
